import script from "./CorpsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CorpsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CorpsDashboard.vue?vue&type=style&index=0&id=41178b74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41178b74"]])

export default __exports__